import Styled from 'styled-components';

const NoCommentsStyled = Styled.div`
  & p {
    font-size: 18px;
  }
  & b {
    font-size: 20px;
  }
`;

const ColumnWrapper = Styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
const AnchorWrapper = Styled.div`
  padding-top: 12px  ;
`;

export default NoCommentsStyled;
export { NoCommentsStyled, ColumnWrapper, AnchorWrapper };
